import { Switch as AntdSwitch, type SwitchProps as AntdSwitchProps } from "antd/es";
import type React from "react";

import "./Switch.css";

export interface SwitchProps extends AntdSwitchProps {
	id?: string;
	form?: string;
}

export const Switch = AntdSwitch as React.FC<SwitchProps>;
